"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sendTwoFactorCodeMultichannel = require("./sendTwoFactorCodeMultichannel");
Object.keys(_sendTwoFactorCodeMultichannel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendTwoFactorCodeMultichannel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendTwoFactorCodeMultichannel[key];
    }
  });
});
var _sendTwoFactorCodeSms = require("./sendTwoFactorCodeSms");
Object.keys(_sendTwoFactorCodeSms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendTwoFactorCodeSms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendTwoFactorCodeSms[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});